// import React from "react";
// import { Segment, Table, Pagination, Button, Form, Grid, Dropdown, Input } from "semantic-ui-react";
// import { toast } from "react-toastify";
// import config from "../../../common/repository/config";
// import LocalStorage from "../../../lib/LocalStorage";

// interface State {
//   doctors: any[];
//   total: number;
//   page: number;
//   limit: number;
//   loading: boolean;
//   year: any;
// }

// export default class DoctorsList extends React.Component<{}, State> {
//   state: State = {
//     doctors: [],
//     total: 0,
//     page: 1,
//     limit: 40,
//     loading: false,
//     year: new Date().getFullYear().toString(),
//   };
//   yearOptions = Array.from({ length: 200 }, (_, i) => {
//     const year = 1900 + i;
//     return { key: year, value: year, text: year };
//   });

//   componentDidMount() {
//     this.fetchDoctors();
//   }
//   private fetchDoctors = async () => {
//     this.setState({ loading: true });
//     const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
//     if (!token) {
//       console.error("Authentication token is missing.");
//       return;
//     }
//     try {
//       const { page, limit } = this.state;
//       const start = (page - 1) * limit;

//       const response = await fetch(`${config.apiBaseURL}/case/getDoctorsList`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-access-token": token,
//         },
//         body: JSON.stringify({
//           year: this.state.year,
//           page: String(page),
//           start: start.toString(),
//           limit: String(limit),
//         }),
//       });

//       if (response.ok) {
//         const data = await response.json();
      
//         if (data.success && data.data && Array.isArray(data.data.items)) {
//           this.setState({
//             doctors: data.data.items,
//             total: data.data.total_item_count || 0,
//           });
      
   
//           if (data.data.items.length === 0) {
//             toast.info(data.message || "No doctors found for the selected year.");
//           }
      
//         } else {
 
//           toast.error(data.message || "Unexpected response format.");
//         }
//       } else {
//         const errorData = await response.json();
//         toast.error(errorData.message || "Failed to fetch doctors");
//       }
      
//     } catch (error) {
//       console.error("Error fetching doctors:", error);
//       toast.error("Error fetching doctors");
//     }
//     this.setState({ loading: false });
//   };

//   private handlePageChange = (_: any, data: any) => {
//     this.setState({ page: data.activePage as number }, () =>
//       this.fetchDoctors()
//     );
//   };
//   // Donwlaod Data 

//   private handleDownloadAll = async () => {
//     this.setState({ loading: true });
//     const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
//     if (!token) {
//       toast.error("Authentication token missing");
//       return;
//     }
//     const { page, limit } = this.state;
//     const start = (page - 1) * limit;

//     try {
//       const response = await fetch(`${config.apiBaseURL}/case/downloadDoctors`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-access-token": token,
//         },
//         body: JSON.stringify({
//           year: this.state.year,
//           page: String(page),
//           start: start.toString(),
//           limit: String(limit),
//         }),
//       });

//       if (!response.ok) throw new Error("Failed to download doctors");

//       const data = await response.json();

//       if (!data.success || !Array.isArray(data.data.items)) {
//         throw new Error("Unexpected data format from download API");
//       }

//       // Generate CSV
//       const csvRows = [
//         ["#", "Year", "Registration No", "Council", "Doctor Name", "Father Name"],
//         ...data.data.items.map((d: any) => [d[0], d[1], d[2], d[3], d[4], d[5]]),
//       ];

//       const csvContent = csvRows.map((row) => row.join(",")).join("\n");
//       const blob = new Blob([csvContent], { type: "text/csv" });
//       const url = window.URL.createObjectURL(blob);

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `doctors_page_${page}.csv`;
//       a.click();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       console.error(err);
//       toast.error("Error downloading doctors for this page");
//     } finally {
//       this.setState({ loading: false });
//     }
//   };

//   render() {
//     const { doctors, total, page, limit, loading,year } = this.state;
//     return (
//       <>
//         {/* Top controls row */}


//         <Segment padded="very" color="blue">
//           <Grid verticalAlign="middle">
//             <Grid.Row columns={2}>
//               {/* Left side: year dropdown with label */}
//               <Grid.Column width={8} textAlign="left">
//                 <Form.Field>

//                   <div style={{ marginBottom: '10px' }}>
//                     <label><strong> Selete Year:</strong></label>
//                     <Dropdown
//                     placeholder="Select Year"
//                     selection
//                     options={this.yearOptions}
//                     value={this.state.year}
//                     onChange={(_, data) =>
//                       this.setState({ year: data.value, page: 1 }, this.fetchDoctors)
//                     }
//                     style={{ minWidth: "150px", marginTop: "5px" }}
//                   />
//                   </div>
//                 </Form.Field>
//               </Grid.Column>

//               {/* Right side: download button */}
//               <Grid.Column width={8} textAlign="right">
//                 <Button
//                   color="blue"
//                   icon="download"
//                   labelPosition="right"
//                   onClick={this.handleDownloadAll}
//                   style={{ fontWeight: "bold" }}
//                 >
//                   Download CSV
//                 </Button>
//               </Grid.Column>
//             </Grid.Row>
//           </Grid>
//         </Segment>

//         {/* Table + Pagination */}
//         <Segment loading={loading}>
//           <Table celled striped>
//             <Table.Header>
//               <Table.Row>
//                 <Table.HeaderCell>#</Table.HeaderCell>
//                 <Table.HeaderCell>Year</Table.HeaderCell>
//                 <Table.HeaderCell>Registration No</Table.HeaderCell>
//                 <Table.HeaderCell>Council</Table.HeaderCell>
//                 <Table.HeaderCell>Doctor Name</Table.HeaderCell>
//                 <Table.HeaderCell>Father Name</Table.HeaderCell>
//               </Table.Row>
//             </Table.Header>

//             <Table.Body>
//               {doctors.length > 0 ? (
//                 doctors.map((doc: any, idx: number) => (
//                   <Table.Row key={idx}>
//                     <Table.Cell>{doc[0]}</Table.Cell>
//                     <Table.Cell>{doc[1]}</Table.Cell>
//                     <Table.Cell>{doc[2]}</Table.Cell>
//                     <Table.Cell>{doc[3]}</Table.Cell>
//                     <Table.Cell>{doc[4]}</Table.Cell>
//                     <Table.Cell>{doc[5]}</Table.Cell>
//                   </Table.Row>
//                 ))
//               ) : (
//                 <Table.Row>
//                   <Table.Cell colSpan="6" style={{ textAlign: "center" }}>
//                     No doctors found
//                   </Table.Cell>
//                 </Table.Row>
//               )}
//             </Table.Body>
//           </Table>

//           {/* Pagination aligned right */}
//           <div style={{ textAlign: "right", marginTop: "15px" }}>
//             <Pagination boundaryRange={0}
//               siblingRange={1}
//               ellipsisItem={null}
//               firstItem={null}
//               lastItem={null}
//               prevItem={{ content: "Prev" }}
//               nextItem={{ content: "Next" }}
//               totalPages={10}
//               activePage={page}
//               onPageChange={this.handlePageChange} />
//           </div>
//         </Segment>
//         <Segment>
//   {/* <h3>Synced Doctor Data (via DownlaoedDoctors):</h3>
//   <DownlaoedDoctors
//     // year={year}
//     limit={limit}
//     offset={(page - 1) * limit}
//     sync={true}
//     iiyy="202408" // just example; replace with actual logic if needed
//   /> */}
// </Segment>
//       </>
//     );
//   }
// }




import React, { useEffect, useState } from "react";
import Page from "../../layout/Page";
import LocalStorage from "../../../lib/LocalStorage";
import { toast } from "react-toastify";
import config from "../../../common/repository/config";
import {Segment, Header, Form, Dropdown, Message, Table, Button, Loader, Pagination  } from "semantic-ui-react";

interface DownlaoedDoctorsProps {
  sync?: boolean;
  iiyy?: string;
  state?: string;
}

interface Doctor {
  id: string;
  name: string;
  specialization: string;
  [key: string]: any;
}

const DownlaoedDoctors: React.FC<DownlaoedDoctorsProps> = ({
  sync,
  iiyy,
  state,
}) => {
  // View Doctors
  const [doctors, setDoctors] = useState<Doctor[]>([]);
  const [loading, setLoading] = useState(false);
  const [viewYear, setViewYear] = useState(String(new Date().getFullYear()));
  const [downloadYear, setDownloadYear] = useState(String(new Date().getFullYear()));
  const [page, setPage] = useState(1);
  const [limit] = useState(40);
  const [total, setTotal] = useState(0);

  // Download Doctors
  const [downloadStart, setDownloadStart] = useState(0);
  const [downloadLimit, setDownloadLimit] = useState(100);
  const [downloading, setDownloading] = useState(false);

  //fetch doctors 
  const fetchDoctors = async () => {
    setLoading(true);

    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Authentication token is missing.");
      setLoading(false);
      return;
    }

    try {
      const offset = (page - 1) * limit;

      const payload: any = {
        year: viewYear,
        limit,
        offset,
      };

      if (state) payload.state = state;
      if (sync !== undefined) payload.sync = sync;
      if (iiyy) payload.iiyy = iiyy;

      const response = await fetch(`${config.apiBaseURL}/case/getDoctors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setDoctors(data.data.items || []);
        setTotal(data.data.total_item_count || 0);
      } else {
        toast.error(data.message || "Failed to fetch doctors.");
        setDoctors([]);
        setTotal(0);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching doctors.");
    } finally {
      setLoading(false);
    }
  };

  //download doctors 
  const downloadDoctors = async () => {
    setDownloading(true);

    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Authentication token is missing.");
      setDownloading(false);
      return;
    }

    try {
      const payload: any = {
        year: downloadYear,
        start: downloadStart,
        limit: downloadLimit,
        page: Math.floor(downloadStart / downloadLimit) + 1,
      };

      const response = await fetch(
        `${config.apiBaseURL}/case/downloadDoctors`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message || "Doctors downloaded successfully.");

        // Refresh the table after download
        fetchDoctors();
      } else {
        toast.error(data.message || "Failed to download doctors.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error downloading doctors.");
    } finally {
      setDownloading(false);
    }
  };

  //export as excel 
  const exportDoctorsExcel = async () => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    try {
      const response = await fetch(
        `${config.apiBaseURL}/case/downloadDoctorsSheet`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          }
        }
      );

      if (!response.ok) {
        const error = await response.json();
        toast.error(error.message || "Failed to export doctors.");
        return;
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `Doctors_Report.xlsx`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Doctors exported successfully.");
    } catch (error) {
      console.error(error);
      toast.error("Unable to export doctors.");
    }
  };

  useEffect(() => {
    fetchDoctors();
  }, [viewYear, page, sync, iiyy, state]);

  const handleViewYearChange = (_: any, data: any) => {
    setViewYear(data.value);
    setPage(1);
  };

  const handleDownloadYearChange = (_: any, data: any) => {
    setDownloadYear(data.value);
  };

  const handlePageChange = (_: any, data: any) => {
    setPage(data.activePage as number);
  };
  const getYearOptions = (startYear = 1947) => {
    const currentYear = new Date().getFullYear();

    return Array.from(
      { length: currentYear - startYear + 1 },
      (_, index) => {
        const year = String(currentYear - index);

        return {
          key: year,
          text: year,
          value: year,
        };
      }
    );
  };

  const yearOptions = getYearOptions();

  return (
    <Page title="Doctors Data">
      <Segment>
        <Header as="h3" dividing>
          Download Doctors
        </Header>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Year</label>
              <Dropdown
                placeholder="Select Year"
                selection
                options={yearOptions}
                value={downloadYear}
                onChange={handleDownloadYearChange}
              />
            </Form.Field>

            <Form.Input
              label="Start"
              type="number"
              min={0}
              value={downloadStart}
              onChange={(_, data) =>
                setDownloadStart(Number(data.value))
              }
            />

            <Form.Input
              label="Limit"
              type="number"
              min={1}
              value={downloadLimit}
              onChange={(_, data) =>
                setDownloadLimit(Number(data.value))
              }
            />
          </Form.Group>

          <Message info>
            <Message.Header>
              Doctors to be downloaded
            </Message.Header>
            <p>
              Doctors{" "}
              <strong>
                {downloadStart + 1} -{" "}
                {downloadStart + downloadLimit}
              </strong>{" "}
              for year <strong>{downloadYear}</strong>.
            </p>
          </Message>

          <Button
            primary
            icon="download"
            content="Download Doctors"
            loading={downloading}
            disabled={downloading}
            onClick={downloadDoctors}
          />

          <Button
            primary
            loading={downloading}
            disabled={downloading}
            icon="download"
            content="Export As Excel"
            onClick={exportDoctorsExcel}
          />
        </Form>
      </Segment>

      <Segment style={{ marginTop: 20 }}>
        <Header as="h3" dividing>
          View Doctors
        </Header>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 15,
          }}
        >
          <Dropdown
            placeholder="Select Year"
            selection
            options={yearOptions}
            value={viewYear}
            onChange={handleViewYearChange}
            style={{ minWidth: 180 }}
          />

          <span style={{ color: "#4183c4" }}>
            Showing {doctors.length} of {total} doctors
          </span>
        </div>

        <Table celled striped selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>ID</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Specialization</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {loading ? (
              <Table.Row>
                <Table.Cell colSpan="3" textAlign="center">
                  <Loader active inline="centered" />
                </Table.Cell>
              </Table.Row>
            ) : doctors.length > 0 ? (
              doctors.map((doctor) => (
                <Table.Row key={doctor.id}>
                  <Table.Cell>{doctor.id}</Table.Cell>
                  <Table.Cell>{doctor.name}</Table.Cell>
                  <Table.Cell>
                    {doctor.specialization || "N/A"}
                  </Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell colSpan="3" textAlign="center">
                  No doctors found.
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>

        <div style={{ textAlign: "right", marginTop: 15 }}>
          <Pagination
            boundaryRange={1}
            siblingRange={1}
            totalPages={Math.ceil(total / limit)}
            activePage={page}
            onPageChange={handlePageChange}
            prevItem={{ content: "Prev" }}
            nextItem={{ content: "Next" }}
          />
        </div>
      </Segment>
    </Page>
  );

}

export default DownlaoedDoctors
